import React from "react";
import { motion } from "framer-motion";

export default function ProjectsCard({
  title,
  description,
  technologies,
  link,
}) {
  return (
    <motion.div
      className="projects-card"
      whileHover={{ y: -10 }}
      transition={{ duration: 0.3 }}
      onClick={() => window.open(link, "_blank")}
    >
      <div className="project-content">
        <h3 className="project-title">{title}</h3>
        <p className="project-description">{description}</p>
        <div className="project-technologies">
          {technologies.map((tech, index) => (
            <span key={index} className="tech-tag">
              {tech}
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
